/**
 * Nav
 */

// Custom
import 'protons';

// Module template
import './_nav.twig';
import './_nav-item.twig';
import $ from 'jquery';

// Import custom sass, includes Bootstrap sass
import './_nav.scss';

export const name = 'nav';

export function disable() {}

export function enable() {}

const jumpMenu = $('.jump-menu');

if (jumpMenu.length) {
  $('.jump-menu').change(function () {
    window.location.href = this.options[this.selectedIndex].value;
  });
}

export default enable;
